export const searchTypes = {
    TRANSACTIONS: 0,
    BLOCKS: 1,
    DATASTORES: 2,
};
